import { parse } from 'query-string'
import { useLocation } from 'react-router-dom'
import { useUseCorporateInvitationQuery } from '../graphql'

function useCorporateInvitation() {
  const { search } = useLocation()
  const { corporatePartnerId, invite } = parse(search)
  const skip = !corporatePartnerId && !invite
  const result = useUseCorporateInvitationQuery({
    variables: {
      id: corporatePartnerId ? String(corporatePartnerId) : undefined,
      token: invite ? String(invite) : undefined,
    },
    skip,
  })

  return {
    ...result,
    active: !skip,
  }
}

export default useCorporateInvitation
